import config from 'config';
import { authHeader } from "../_helpers";
import axios from 'axios';

export const userService = {
  login,
  logout,
  requestPasswordReset,
  requestIsTokenValid,
  changePassword,
  PasswordStrengthMeter,
  userBelongsToGroup
}

function userBelongsToGroup(groupName) {
  const myGroups = JSON.parse(localStorage.getItem('groups'));
  //console.log(myGroups)
  let groupFounded = false
  if (myGroups.all_groups.some(e => e.name == groupName)) {
    groupFounded = true
    //console.log("El usuario está en el grupo " + groupName)
  }
  return groupFounded
}


function login(username, password) {
  const requestOptions = {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ username, password })
  };
  return fetch(`${config.apiUrl}/api/token/`, requestOptions)
    .then(handleResponse)
    .then(user => {
      if (user.access) {
        localStorage.setItem('user', JSON.stringify(user));
        var groups = getMyGroups()
        localStorage.setItem('groups', JSON.stringify(groups));
        var userInfo = getUserInfo()
        localStorage.setItem('userInfo', JSON.stringify(userInfo));
      }
      //console.log("Mi usuario: " + userInfo)
      //console.log("Mis grupos: " + groups)
      return user;
    })
}

function logout() {
  localStorage.removeItem('user');
}

async function getMyGroups() {

  const requestOptions = {
    method: 'GET',
    headers: { Authorization: `Bearer ${JSON.parse(localStorage.getItem("user")).access}` },
    'Content-Type': 'application/json'
  };
  return fetch(`${config.apiUrl}/user/my-groups/`, requestOptions)
    .then(handleResponse)
    .then(groups => {
      if (groups) {
        localStorage.setItem('groups', JSON.stringify(groups));
      }
      //console.log(groups)
      return groups;
    })
}

async function getUserInfo() {

  const requestOptions = {
    method: 'GET',
    headers: { Authorization: `Bearer ${JSON.parse(localStorage.getItem("user")).access}` },
    'Content-Type': 'application/json'
  };
  return fetch(`${config.apiUrl}/user/user-info/`, requestOptions)
    .then(handleResponse)
    .then(userInfo => {
      if (userInfo) {
        localStorage.setItem('userInfo', JSON.stringify(userInfo));
      }
      //console.log(userInfo)
      return userInfo;
    })
}

function handleResponse(response) {
  return response.text().then(text => {
    const data = text && JSON.parse(text);
    if (!response.ok) {
      if (response.status == 401) {
        logout();
        location.reload(true);
      }
      const error = (data && data.message) || response.statusText;
      return Promise.reject(error);
    }
    localStorage.setItem('groups', JSON.stringify(data));
    return data;
  }
  )
}

async function requestPasswordReset(email) {
  const axios = require('axios')
  var respuesta = ''
  var code = 0
  var request = await axios.post(`${config.apiUrl}/user/accounts/password-reset/`, {
    email: email
  }, {
    headers: {
      'content-type': 'application/json'
    }
  }
  )
    .then((res) => {
      //console.log(res.data)
      respuesta = 'Se le ha enviado un email a ' + email + ' con instrucciones para restaurar la contraseña.'
      code = 200
    })
    .catch((error) => {
      code = error.response.status
      if (error.response.status == 400) {
        respuesta = 'El email proporcionado no es de ningún usuario de la intranet.'
      } else {
        respuesta = 'Ha habido un problema al recuperar la contraseña. Por favor, contacte con su administrador.'
      }
    })
  return {
    respuesta: respuesta,
    request: request,
    code: code
  }
}

async function requestIsTokenValid(token) {
  const axios = require('axios')
  var respuesta = ''
  var code = 0
  var request = await axios.post(`${config.apiUrl}/user/accounts/password-reset/validate_token/`, {
    token: token
  }, {
    headers: {
      'content-type': 'application/json'
    }
  }
  )
    .then((res) => {
      //console.log(res.data)
      respuesta = res.data
      code = 200
    })
    .catch((error) => {
      code = error.response.status
      if (error.response.status == 400) {
        respuesta = 'Error 400.'
      } else {
        respuesta = 'Error servidor.'
      }
    })
  return {
    respuesta: respuesta,
    request: request,
    code: code
  }
}

async function changePassword(token, newPassword) {
  const axios = require('axios')
  var respuesta = ''
  var code = 0
  var request = await axios.post(`${config.apiUrl}/user/accounts/password-reset/confirm/`, {
    token: token,
    password: newPassword
  }, {
    headers: {
      'content-type': 'application/json'
    }
  }
  )
    .then((res) => {
      respuesta = 'Se ha cambiado la contraseña. A partir de este momento puede ingresar en el sistema'
      code = 200
    })
    .catch((error) => {
      code = error.response.status
      if (error.response.status == 400) {
        respuesta = 'Ha habido algún problema al cambiar la contraseña. Contacte con su administrador'
      } else {
        respuesta = 'Ha habido algún problema al cambiar la contraseña. Contacte con su administrador'
      }
    })
  return {
    respuesta: respuesta,
    request: request,
    code: code
  }
}

function PasswordStrengthMeter(contrasenna) {
  var mayuscula = false;
  var minuscula = false;
  var numero = false;
  var caracter_raro = false;
  var longitud = contrasenna.length

  for (var i = 0; i < contrasenna.length; i++) {
    if (contrasenna.charCodeAt(i) >= 65 && contrasenna.charCodeAt(i) <= 90) {
      mayuscula = true;
    } else if (contrasenna.charCodeAt(i) >= 97 && contrasenna.charCodeAt(i) <= 122) {
      minuscula = true;
    } else if (contrasenna.charCodeAt(i) >= 48 && contrasenna.charCodeAt(i) <= 57) {
      numero = true;
    } else {
      caracter_raro = true;
    }
  }

  return {
    longitud: longitud,
    mayuscula: mayuscula,
    minuscula: minuscula,
    caracter_raro: caracter_raro,
    numero: numero
  }
}
